<template>
    <header id="m_header" class="m-grid__item    m-header " m-minimize-offset="200" m-minimize-mobile-offset="200">
				<div class="m-container m-container--fluid m-container--full-height">
					<div class="m-stack m-stack--ver m-stack--desktop">

						<!-- BEGIN: Brand -->
						<div class="m-stack__item m-brand  m-brand--skin-light ">
							<div class="m-stack m-stack--ver m-stack--general">
								<div class="m-stack__item m-stack__item--middle m-brand__logo">
									<a href="index.html" class="m-brand__logo-wrapper">
										<img alt="" src="../assets/MdtImages/mdtCloud-logo-small.png" />
									</a>
								</div>
								<div class="m-stack__item m-stack__item--middle m-brand__tools">

									<!-- BEGIN: Left Aside Minimize Toggle -->
									<a href="javascript:;" id="m_aside_left_minimize_toggle" class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block  ">
										<span></span>
									</a>

									<!-- END -->

									<!-- BEGIN: Responsive Aside Left Menu Toggler -->
									<a href="javascript:;" id="m_aside_left_offcanvas_toggle" class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block">
										<span></span>
									</a>

									<!-- END -->

									<!-- BEGIN: Responsive Header Menu Toggler -->
									<a id="m_aside_header_menu_mobile_toggle" href="javascript:;" class="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block">
										<span></span>
									</a>

									<!-- END -->

									<!-- BEGIN: Topbar Toggler -->
									<a id="m_aside_header_topbar_mobile_toggle" href="javascript:;" class="m-brand__icon m--visible-tablet-and-mobile-inline-block">
										<i class="flaticon-more"></i>
									</a>

									<!-- BEGIN: Topbar Toggler -->
								</div>
							</div>
						</div>

						<!-- END: Brand -->
						<div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">



							<!-- BEGIN: Horizontal Menu -->
							<button class="m-aside-header-menu-mobile-close  m-aside-header-menu-mobile-close--skin-light " id="m_aside_header_menu_mobile_close_btn"><i class="la la-close"></i></button>

							<!-- END: Horizontal Menu -->

							<!-- BEGIN: Topbar -->
							<div id="m_header_topbar" class="m-topbar  m-stack m-stack--ver m-stack--general m-stack--fluid">
								<div class="m-stack__item m-topbar__nav-wrapper">
									<ul class="m-topbar__nav m-nav m-nav--inline">
										<Notification></Notification>
										<li class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
										 m-dropdown-toggle="click">
											<a href="#" class="m-nav__link m-dropdown__toggle">
												<span class="m-topbar__userpic">
													<img src="../assets/MdtImages/default-user-ben.png" class="m--img-rounded m--marginless" alt="" />
												</span>
												<span class="m-topbar__username m--hide">Nick</span>
											</a>
											<div class="m-dropdown__wrapper">
												<span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
												<div class="m-dropdown__inner">
													<div class="m-dropdown__header m--align-center" style="background-color:#3a77fe;">
														<div class="m-card-user m-card-user--skin-dark">
															<div class="m-card-user__pic">
																<img src="../assets/MdtImages/default-user-ben.png" class="m--img-rounded m--marginless" alt="" />

																<!--
						<span class="m-type m-type--lg m--bg-danger"><span class="m--font-light">S<span><span>
						-->
															</div>
															<div class="m-card-user__details">
																<span class="m-card-user__name m--font-weight-500">{{this.user.fullName}} </span>
																<span href="" style="color:white !important;text-decoration:none" class="m-card-user__email m--font-weight-300">{{this.user.email}}</span>

															</div>
														</div>
													</div>
													<div class="m-dropdown__body">
														<div class="m-dropdown__content text-center">
															<ul class="m-nav m-nav--skin-light profile-buttons">
																<li class="m-nav__section m--hide">
																	<span class="m-nav__section-text">Section</span>
																</li>
																<li class="m-nav__item">
																	<a @click="GotoUserProfile()" style="font-family:arial; margin-left:65px;" class="btn btn-light"><b> Profilim </b></a>
																</li>	
																<li class="m-nav__item">
																	<a @click="GotoTenantProfile()" class="btn btn-light" style="font-family:arial;margin-left:65px" ><b>Şirket Profili</b></a>
																</li>
																<li class="m-nav__item">
																	<a @click="Logout()" class="btn btn-light"  style="font-family:arial;margin-left:65px"><b>Çıkış</b></a>
																</li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</li>
										<li id="m_quick_sidebar_toggle-1" class="m-nav__item">
											<a href="#" class="m-nav__link">
												<span class="m-nav__link-icon"><i class="flaticon-settings"></i></span>
											</a>
										</li>
									</ul>
								</div>
							</div>

							<!-- END: Topbar -->
						</div>
					</div>
				</div>
			</header>
</template>
<script>
import Notification from './Notification'
import { _getMyProfile} from "../services/UserService";

export default {
	 created() {
    this.getMyProfile();
  },
	data() {
    return {
      user: {
        id: 0,
        fullName: "",
        email: "",
        userName: "",
        password: "",
        repeatPassword: "",
        tenantId: this.$store.getters.tenantId
      }
    };
  },
	methods: {
		Logout(){
			this.$store.dispatch('REMOVE_TOKEN');
			location.reload();
		},
		GotoTenantProfile(){
			this.$router.push({ name: 'tenantProfile' });
		},
		GotoUserProfile() {
						this.$router.push({ name: 'userProfile' });
		},
		 getMyProfile: function() {
      _getMyProfile().then(response => {
              if (response.data.success)
        {
  
          this.user = response.data.data;
          //set Password values to empty string if it is not changed password is not updated in service
          this.user.repeatPassword ="";
          this.user.password ="";
        }
        else 
                  this.$router.push("/");
      });
    }
	},
	components:{
Notification
	}
}
</script>

<style lang="scss" scoped>
.profile-buttons{
	display:flex;
	flex-direction:column;
	justify-content:space-between;
	height:15vh;
}

.profile-buttons > li > * {
	border:none;
	border-radius:0px;
	border-bottom:1px solid #3A77FE;
	width: 150px;
	float:left ;
} 

</style>